import { HTMLProps, forwardRef } from 'react'

export type NumberInputProps = HTMLProps<HTMLInputElement> & {
  label?: string
  labelClassName?: string
  description?: string
  descriptionClassName?: string
  inputClassName?: string
  error?: string | undefined
}

export const NumberInput = forwardRef<HTMLInputElement, NumberInputProps>(
  ({ label, labelClassName, description, descriptionClassName, inputClassName, error, ...props }, ref) => {
    return (
      <div className="flex flex-col gap-y-2">
        {label && (
          <span className={`text-white text-sm font-semibold ${labelClassName && labelClassName}`}>{label}</span>
        )}
        {description && (
          <p className={`text-xs leading-5 text-white opacity-70 ${descriptionClassName ? descriptionClassName : ''}`}>
            {description}
          </p>
        )}
        <div>
          <input
            ref={ref}
            type="number"
            onWheel={(e: any) => e.target.blur()}
            {...props}
            className={`p-3 text-sm md:p-[17px] rounded-full w-full focus:outline-none text-navy-900 
              border border-navy-900 border-opacity-20 ${inputClassName ? inputClassName : ''} ${
                props.disabled ? 'bg-slate-200' : ''
              }`}
          />
        </div>
        {!props.disabled && error && <div className="text-boldOrange -mt-1 font-medium">{error}</div>}
      </div>
    )
  }
)
